export const GROUP_DETAIL_CHANGED = "groupDetailChanged";
export const GROUP_MEMBER_DETAIL_CHANGE = "groupMemberDetailChanged";

export const SAMPLE_GROUP_DETAIL_CHANGED = "sampleGroupDetailChanged";
export const SAMPLE_GROUP_SAMPLES_DETAIL_CHANGE =
  "sampleGroupSamplesDetailChanged";

export const SAMPLE_TELP_INTV_CHANGED = "sampleTelpIntvChanged";
export const SAMPLE_RESET_LIST_CHANGED = "sampleResetListChanged";